class ProductViewTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.tab-btn');
    this.panels = this.querySelectorAll('.tab-panel');
    
    // Get product ID from data attribute or Liquid variable
    const productId = this.dataset.productId || window.productId || 'default';
    this.storageKey = `product_view_selected_tab_${productId}`;
    this.init();
  }

  init() {
    this.buttons.forEach(button => {
      button.addEventListener('click', () => this.switchTab(button));
    });

    // Load last selected tab (if available) and switch to it
    try {
      const savedTab = window.localStorage.getItem(this.storageKey);
      if (savedTab) {
        const savedButton = Array.from(this.buttons).find(b => b.dataset.tab === savedTab);
        if (savedButton) {
          this.switchTab(savedButton);
        }
      }
    } catch (e) {
      // Safely ignore storage errors (private mode, disabled storage, etc.)
    }
  }

  switchTab(button) {
    const targetTab = button.dataset.tab;
    
    // Update buttons
    this.buttons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
    
    // Update panels
    this.panels.forEach(panel => {
      if (panel.dataset.panel === targetTab) {
        panel.classList.add('active');
      } else {
        panel.classList.remove('active');
      }
    });

    // Persist selection to localStorage
    try {
      window.localStorage.setItem(this.storageKey, targetTab);
    } catch (e) {
      // Safely ignore storage errors
    }

    // Trigger resize and re-initialization after tab switch
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      
      if (targetTab === '3d') {
        // Resize 3D canvas
        const canvas = this.querySelector('#canvas-container canvas');
        if (canvas && window.renderer) {
          const container = this.querySelector('#canvas-container');
          if (container) {
            window.renderer.setSize(container.offsetWidth, container.offsetHeight);
            if (window.camera) {
              window.camera.aspect = container.offsetWidth / container.offsetHeight;
              window.camera.updateProjectionMatrix();
            }
          }
        }
      } else if (targetTab === 'gallery') {
        // Re-trigger gallery/slideshow initialization
        const slideshow = this.querySelector('[data-product-slideshow]');
        if (slideshow && window.Flickity) {
          const flickityInstance = Flickity.data(slideshow);
          if (flickityInstance) {
            flickityInstance.resize();
          }
        }
      }
    }, 100);
  }
}

customElements.define('product-view-tabs', ProductViewTabs);
